import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "seats-and-hour-packs",
  courseId: "for-agency-admins",
  order: 7,
  title: "Seats and hours",
  subtitle: "Investigator and footage add-ons",
  summary:
    "Investigator and footage seats work the same way: buy seats, assign them per officer, and the department gets a pooled allowance of audio or video minutes per billing period, topped up with hour packs.",
  learn: [
    "Buy investigator and footage seats, monthly or annual",
    "Assign seats from the officer table",
    "Read the pool warnings and add hours",
  ],
  minutes: 4,
  releasedAt: "2026-09-24T00:00:00.000Z",
  gate: "admin",
  body: [
    {
      type: "paragraph",
      text: "On the **Officers** tab, two bars sit above the officer table: Investigator seats and Footage analysis seats. Each shows the interval, the renewal date, and whether the department's pool is running low.",
    },
    {
      type: "steps",
      items: [
        "Click **Add seats** on a bar. On the first purchase choose Annual or Monthly.",
        "To assign an investigator seat, choose Investigator in an officer's Role dropdown. To assign footage, use the **Footage** toggle. Revoke the same way.",
        "When the bar warns that most or all of the hours are used, click **Add hours** for a one-time pack.",
      ],
    },
    {
      type: "paragraph",
      text: "The department keeps the interval you chose on the first purchase for later additions. Each investigator seat adds 50 hours of audio a month to the shared pool, assigned or not. Each footage seat adds 10 hours of video. Annual plans receive the year's hours up front. A pack is 100 investigation hours or 25 footage hours, and packs never roll over.",
    },
    {
      type: "callout",
      tone: "note",
      title: "Nothing hard-stops",
      text: "Going over the pool never blocks reads or deletes anything. At 150 percent of allowance an officer's uploads are soft-throttled to 10 an hour. You also get an email at 80, 100, and 150 percent of the period's pool.",
    },
    {
      type: "callout",
      tone: "tip",
      title: "Seats mid-year",
      text: "Adding seats mid-year on an annual plan adds the prorated hours for the months remaining, matching the prorated charge. Removing seats subtracts the same way.",
    },
    {
      type: "paragraph",
      text: "Case footage (the **Analyze the footage** toggle on ordinary reports) draws from the footage pool too. Video in an investigation counts three minutes of allowance per minute of footage.",
    },
    {
      type: "paragraph",
      text: "For the role side of assigning seats, see Invite officers. For what the footage toggle does, see Verify vs enrich.",
    },
  ],
  related: ["invite-officers-and-roles", "bulk-upload-jail-calls", "verify-vs-enrich"],
};

export default lesson;
